module.exports = __webpack_public_path__ + "static/media/steel.a9cba894.png";